import { createContext, useContext, useEffect, useState } from "react";
import { apiLogin, apiMe } from "../lib/api";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = unknown, false = unauth, obj = auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    apiMe()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem("auth_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const { token, user: u } = await apiLogin(username, password);
    localStorage.setItem("auth_token", token);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("auth_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
